// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_about_pageContainer_3zEru","logoImg":"_about_logoImg_3zipN","titleText":"_about_titleText_SFUga","contentText":"_about_contentText_1pwag"};